import {ChangeDetectorRef, Component} from "@angular/core";
import {provideEntityModel} from "@fedeltapointofsale/data-client";
import {SizeGroupEntityModel} from "../size-group-entity.model";
import {AbstractEditPage} from "../../../framework/entity/edit/edit-page/abstract-edit-page";
import {FUIResponsiveService} from "@fedeltapointofsale/ui";

@Component({
    selector: "wbo-size-group-edit-page",
    templateUrl: "./size-group-edit-page.component.html",
    providers: [provideEntityModel(SizeGroupEntityModel)]
})
export class SizeGroupEditPageComponent extends AbstractEditPage {
    constructor(public model: SizeGroupEntityModel,
                changeDetectorRef: ChangeDetectorRef,
                responsiveService: FUIResponsiveService) {
        super(changeDetectorRef, responsiveService);
    }
}
